/**
 * 環境判定ユーティリティ
 */
import Constants from "expo-constants"

export type AppEnv = "dev" | "stg" | "prd"

/**
 * 現在のアプリ環境を取得
 */
export function getAppEnv(): AppEnv {
  // expo-constantsから環境情報を取得
  const env = Constants.expoConfig?.extra?.env as AppEnv | undefined

  // フォールバック: __DEV__フラグを使用
  if (!env) {
    return __DEV__ ? "dev" : "prd"
  }

  return env
}

/**
 * 開発環境かどうか
 */
export function isDev(): boolean {
  return getAppEnv() === "dev"
}

/**
 * ステージング環境かどうか
 */
export function isStaging(): boolean {
  return getAppEnv() === "stg"
}

/**
 * 本番環境かどうか
 */
export function isProduction(): boolean {
  return getAppEnv() === "prd"
}
